// extracted by mini-css-extract-plugin
export default {"Tags":"Tags_Tags__7VrQ4","Tags__item":"Tags_Tags__item__Nreli"};